export default __webpack_public_path__ + "../staticImages/wood-box.png";